import { FrameProduct, SizeLabel } from '../';

export function IsSmallSize(product: FrameProduct): product is FrameProduct {
  return product.drawableObject.sizeLabel === SizeLabel.S;
}
